import {
  Chip,
  IconButton,
  ListItem,
  ListItemText,
  Tooltip,
} from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import GetAppIcon from "@material-ui/icons/GetApp";
import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { CustomerGroupListItem } from "../../../../lib/models/CustomerGroupListItem";
import { Dispatch } from "../../../../store";
import { ICustomerGroupExport } from "../../../../types/index";
import { format as formatDate } from "../../../../utilities";
import ConfirmationDialog from "../../../generic/ConfirmationDialog";

interface Props {
  customerGroup: CustomerGroupListItem;
  customerGroupExport: ICustomerGroupExport;
}

export default function CustomerGroupExport({
  customerGroup,
  customerGroupExport,
}: Props) {
  const classes = useStyles();
  const dispatch = useDispatch<Dispatch>();

  const onDownloadExport = () => {
    dispatch.customerGroupList.downloadCustomerGroupExport({
      customerGroupUuid: customerGroup.uuid,
      customerGroupExportUuid: customerGroupExport.uuid,
    });
  };

  const [showConfirmDeleteDialog, setShowConfirmDeleteDialog] = useState(false);
  const onDeleteExport = () => {
    setShowConfirmDeleteDialog(true);
  };
  const handleDeleteExportAbort = () => {
    setShowConfirmDeleteDialog(false);
  };
  const handleDeleteExportConfirm = () => {
    setShowConfirmDeleteDialog(false);
    dispatch.customerGroupList.deleteCustomerGroupExport({
      customerGroupUuid: customerGroup.uuid,
      customerGroupExportUuid: customerGroupExport.uuid,
    });
  };

  return (
    <>
      <ListItem
        key={customerGroupExport.uuid}
        className={classes.exportListItem}
        button
        disableRipple
      >
        <ListItemText
          primary={formatDate(
            new Date(customerGroupExport.createdAt),
            "dd. MMMM yyyy 'um' HH:mm 'Uhr'"
          )}
          secondary={
            customerGroupExport.comment
              ? customerGroupExport.comment
              : "Ohne Bezeichnung gespeichert."
          }
          className={classes.exportListItemText}
        />
        <Chip
          label={`${customerGroupExport.numResults} Kunden`}
          color="secondary"
          variant="outlined"
        />
        <div className={classes.exportActionButtons}>
          <Tooltip title="Kundennummern downloaden">
            <IconButton onClick={onDownloadExport}>
              <GetAppIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Löschen">
            <IconButton onClick={onDeleteExport} edge="end">
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </div>
      </ListItem>

      <ConfirmationDialog
        open={showConfirmDeleteDialog}
        onAbort={handleDeleteExportAbort}
        onClose={handleDeleteExportAbort}
        onConfirm={handleDeleteExportConfirm}
        text="Soll dieser Export wirklich gelöscht werden?"
      />
    </>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    exportListItem: {
      justifyContent: "space-between",
      cursor: "auto",
      userSelect: "auto",
    },
    exportListItemText: {
      minWidth: 280,
      marginRight: 16,
    },
    exportActionButtons: { paddingLeft: 16 },
    deleteButton: {
      marginLeft: "auto",
    },
  })
);



// WEBPACK FOOTER //
// ./src/components/CustomerGroups/CustomerGroup/CustomerGroupExport/CustomerGroupExport.tsx